import { useQuery } from '@tanstack/react-query'
import { data } from '@portal/pkg-api/shared'
import { AssumptionApi } from '@portal/pkg-api/navigator'
import { Assumption } from '@portal/pkg-api/gen/navigator'

const prefix = 'navigator.assumption'

export const AssumptionQueries = {
  assumptions: (entityType?: number) => ({
    queryKey: [`${prefix}.assumptions`, entityType],
    queryFn: (): Promise<Array<Assumption>> =>
      data(
        entityType ? AssumptionApi.getAssumptions(entityType) : AssumptionApi.getAllAssumptions(),
      ),
  }),
  entityAssumptionDetail: (entityAssumptionId?: number) => ({
    queryKey: [`${prefix}.entityAssumptionDetail`, entityAssumptionId],
    queryFn: () => data(AssumptionApi.getEntityAssumtionDetail(entityAssumptionId!)),
    enabled: !!entityAssumptionId,
  }),
  categories: () => ({
    queryKey: [`${prefix}.categories`],
    queryFn: () => data(AssumptionApi.getCategories()),
  }),
}

export function useAssumptions(entityType?: number) {
  return useQuery(AssumptionQueries.assumptions(entityType))
}

export function useEntityAssumptionDetail(entityAssumptionId?: number) {
  return useQuery(AssumptionQueries.entityAssumptionDetail(entityAssumptionId))
}
